import { InvoiceAccountantAreaService } from "core/service";
import BaseRepository from "core/repository/base.repository";

class InvoiceAccountantAreaRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "invoice-accountant-area";
  }

  resourceName() {
    return "nota-fiscal-area-do-contador";
  }

  getServiceProvider() {
    return InvoiceAccountantAreaService;
  }

  async getActiveSerie(companyUuid) {
    return this.mService.getActiveSerie(companyUuid);
  }

  async getAllSeries(companyUuid) {
    return this.mService.getAllSeries(companyUuid);
  }

  async create(body) {
    return this.mService.create(body);
  }

  async deactivate(serie_id) {
    return this.mService.deactivate(serie_id);
  }

  async activate(serie_id) {
    return this.mService.activate(serie_id);
  }
}

export default new InvoiceAccountantAreaRepository();



// WEBPACK FOOTER //
// ./src/core/repository/invoice-accountant-area.repository.js